

































import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";
import { AppModule } from "@/store/modules/app"
import { FramePuzzleModule, PuzzleFormat } from '@/store/modules/framePuzzle';
import FrameImageBig from '@/components/products/framepuzzle/FrameImageBig.vue'
import FramePuzzleEditorPassive from "@/components/products/framepuzzle/FramePuzzleEditorPassive.vue"

@Component({
  name: "puzzle-preview",
  components: {
    FramePuzzleEditorPassive,
    FrameImageBig
  }
})

export default class PuzzlePreview extends Vue {
  transformedOffsetX: number = 0
  transformedOffsetY: number = 0

  get availableDesigns() {
    return FramePuzzleModule.availableDesigns
  }


  get editorScaleX() {
    if (this.isLandscapeFormat) {
      return 1.478
    } else {
      return 1.288
    }
  }

  get editorScaleY() {
    if (this.isLandscapeFormat) {
      return 1.469
    } else {
      return 1.297
    }
  }

  get imageEditorWidth() {
    return FramePuzzleModule.imageEditorWidth
  }

  get imageEditorHeight() {
    return FramePuzzleModule.imageEditorHeight
  }

  get show() {
    return AppModule.showPreview;
  }

  get isLandscapeFormat() {
    return FramePuzzleModule.isLandscapeFormat
  }

  get parts() {
    return FramePuzzleModule.parts
  }

  @Watch('show')
  showChanged(newShow: boolean) {
    if (newShow) {
      this.$nextTick(() => {
        this.setUserImg()
        this.resized()
      })
    }
  }

  get format() {
    if (FramePuzzleModule.format === PuzzleFormat.LANDSCAPE) {
      return 'landscape'
    }
    return 'portrait'
  }

  setUserImg() {
    this.setTransformedOffsetX()
    this.setTransformedOffsetY()
  }

  setTransformedOffsetX() {
    if (this.isLandscapeFormat) {
      this.transformedOffsetX = 45
    } else {
      this.transformedOffsetX = 40.5
    }
  }

  setTransformedOffsetY() {
    if (this.isLandscapeFormat) {
      this.transformedOffsetY = 127.5
    } else {
      this.transformedOffsetY = 90.5
    }
  }

  onClose() {
    AppModule.SetShowPreview(false);
  }

  resized() {
    let width = window.innerWidth;
    let height = window.innerHeight;
    let scale = 1;
    let innerScale = 1
    let innerPortrairScale = 1
    if (width < 800) {
      if (width > height) {
        scale = (height - 130) / 700
        innerScale = 1
      } else {
        scale = width / (width + 100)
        if (scale < 1) {
          innerScale = scale * 5.14520305 - 3.57
          innerPortrairScale = scale * 5.27 - 3.45 < 1 ? scale * 5.27 - 3.45 : 1

        }
      }
    } else if (height < 800) {
      scale = (height - 100) / 700
      innerScale = 1
    }
    if (this.$refs.container) {
      (this.$refs.container as HTMLElement).style.transform =
        "scale(" + scale + ")";
    }
    let previewChildren = document.getElementsByClassName('preview-child')
    Array.from(previewChildren).forEach((child) => {
      if (this.isLandscapeFormat) {
        (child as HTMLElement).style.transform = "scale(" + innerScale + ") translate(0,-50%)";
      } else {
        (child as HTMLElement).style.transform = "scale(" + innerPortrairScale + ") translate(0,-50%)";
      }
    })
  }

  mounted() {
    this.setUserImg()
    window.addEventListener("resize", this.resized)
    this.resized()
  }

  beforeDestroy() {
    window.removeEventListener("resize", this.resized)
  }
}
